  <!--Update profile section goes here-->
  <div class="d-flex justify-content-between align-items-center" *ngIf="userService.isOrionUser()">
    <ng-container *ngIf="showUpdateProfile">
      <div
        class="mail-order-pending d-flex"
        *ngIf="this.showUpdateProfileDialog$ | async"
      >
        <img src="../../../assets/images/warning-icon.svg" alt="loader" class="warning" />  
        <span>{{
          multilingualService.langMap?.LABEL_PRESCRIPTION_UPDATE_PROFILE
        }}</span>
        <button
          mat-raised-button
          class="primary-button uppercase"
          (click)="updateMailOrderProfile()"
        >
          {{ multilingualService.langMap?.LABEL_COMMON_CREATE_BUTTON }}
        </button>
        <!-- <button
          class="close"
          mat-icon-button
          (click)="hideUpdateProfileDialog()"
          [attr.aria-label]="multilingualService?.langMap?.LABEL_CLOSE_DIALOG"
        >
          <mat-icon class="icon-cross"></mat-icon>
        </button> -->
      </div>
    </ng-container>
</div>
